import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import CircularProgress from "@material-ui/core/CircularProgress";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    minWidth: 550,
    maxWidth: 500,
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  const onLogout = () => {
    window.localStorage.removeItem("ckAdminUser");
    window.location.replace("#/login");
  };
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          color="primary"
          className={classes.btnLogout}
          onClick={onLogout}
        >
          Logout
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  buttonPanel: {
    marginTop: 30,
    marginBottom: 20,
    justifyContent: "center",
    display: "flex",
  },
  btnLogout: {
    fontSize: 14,
    textDecoration: "underline",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const LoginMenu = (props) => {
  const { handleClose, open } = props;
  const classes = useStyles();
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(false);

  const onLogout = () => {
    window.location.replace("#/logout");
  };

  return (
    <div>
      <Dialog
        disableScrollLock
        disableEscapeKeyDown
        disableBackdropClick
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="customized-dialog-title">Login</DialogTitle>
        <DialogContent>
          <span>Your session has been expired, Please login to continue.</span>
          <form onSubmit={(e) => onLogout(e)} className={classes.form}>
            <div className={classes.buttonPanel}>
              <Button
                type="submit"
                variant="contained"
                style={{
                  backgroundColor: `${isLoading ? "#6272ce" : ""}`,
                  width: "85%",
                }}
                color="primary"
                disabled={isLoading}
              >
                {isLoading ? (
                  <CircularProgress style={{ color: "white" }} size={24} />
                ) : (
                  "Re-Login"
                )}
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

LoginMenu.propTypes = {
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  reload: PropTypes.bool,
};

LoginMenu.defaultProps = {
  handleClose: (fn) => fn,
  open: false,
  reload: false,
};

export default LoginMenu;
